import { render, staticRenderFns } from "./noteDetail.vue?vue&type=template&id=3b7295e1&scoped=true"
import script from "./noteDetail.vue?vue&type=script&lang=js"
export * from "./noteDetail.vue?vue&type=script&lang=js"
import style0 from "./noteDetail.vue?vue&type=style&index=0&id=3b7295e1&lang=scss"
import style1 from "./noteDetail.vue?vue&type=style&index=1&id=3b7295e1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7295e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b7295e1')) {
      api.createRecord('3b7295e1', component.options)
    } else {
      api.reload('3b7295e1', component.options)
    }
    module.hot.accept("./noteDetail.vue?vue&type=template&id=3b7295e1&scoped=true", function () {
      api.rerender('3b7295e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/record/calssModule/noteDetail.vue"
export default component.exports